/* Grasslands add-ons — replaces the Outsell popup.
   1. PDP: ticked "Add for planting" items go into the basket in the same
      /cart/add.js request as the plant (one notification, one cart update).
   2. Cart notification: a "Complete your order" strip of one-tap Add buttons,
      specific to the plant just added (from the PDP's template) or a generic
      pair elsewhere. Items already in the basket are left out. */
(function () {
  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  function sectionIds(cart) {
    return cart && typeof cart.getSectionsToRender === 'function' ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
  }
  function swapSection(id, html, selector) {
    var el = document.getElementById(id);
    if (!el || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector(selector || '.shopify-section');
    if (src) el.innerHTML = src.innerHTML;
  }
  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

  /* ---- 1. combined add from the PDP form ---- */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    var block = document.querySelector('gl-pdp-addons');
    if (!block) return;
    var ticked = [].slice.call(block.querySelectorAll('[data-gl-addon]:checked'));
    if (!ticked.length) return; // nothing extra: let Dawn's own handler run

    evt.preventDefault();
    evt.stopImmediatePropagation();

    var productForm = form.closest('product-form');
    var submit = form.querySelector('[type="submit"]');
    if (submit && submit.getAttribute('aria-disabled') === 'true') return;
    var spinner = productForm && productForm.querySelector('.loading__spinner');
    if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.classList.add('loading'); }
    if (spinner) spinner.classList.remove('hidden');

    var fd = new FormData(form);
    var variantId = parseInt(fd.get('id'), 10);
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    var items = [{ id: variantId, quantity: qty }];
    // Line-item properties / selling plans from the form carry across to the plant line.
    fd.forEach(function (v, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (m) { items[0].properties = items[0].properties || {}; items[0].properties[m[1]] = v; }
      if (k === 'selling_plan' && v) items[0].selling_plan = v;
    });
    ticked.forEach(function (cb) { items.push({ id: parseInt(cb.value, 10), quantity: 1 }); });

    var cart = getCart();
    var body = { items: items };
    var ids = sectionIds(cart);
    if (ids.length) { body.sections = ids; body.sections_url = window.location.pathname; }
    if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) {
        var wrap = productForm && productForm.querySelector('.product-form__error-message-wrapper');
        var msg = productForm && productForm.querySelector('.product-form__error-message');
        if (wrap && msg) { wrap.hidden = false; msg.textContent = res.description || res.message || 'Could not add to basket'; }
        return;
      }
      var lines = res.items || [];
      var plantLine = lines.filter(function (i) { return i.variant_id === variantId; })[0] || lines[0] || {};
      if (window.publish && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId, cartData: res });
      }
      if (!cart) { window.location = cartUrl; return; }
      ticked.forEach(function (cb) { cb.checked = false; });
      cart.renderContents(Object.assign({}, plantLine, { sections: res.sections }));
    }).catch(function (e) { console.error(e); }).finally(function () {
      if (submit) { submit.classList.remove('loading'); submit.removeAttribute('aria-disabled'); }
      if (spinner) spinner.classList.add('hidden');
    });
  }, true);

  /* ---- 2. "Complete your order" strip in the notification ---- */
  function fillUpsell() {
    var box = document.querySelector('[data-gl-upsell]');
    var list = box && box.querySelector('[data-gl-upsell-list]');
    if (!box || !list) return;
    var tpl = document.querySelector('template[data-gl-upsell-tpl]') || document.querySelector('template[data-gl-upsell-fallback]');
    if (!tpl) { box.hidden = true; return; }
    list.innerHTML = tpl.innerHTML;
    var head = box.querySelector('[data-gl-upsell-heading]');
    if (head && tpl.dataset.heading) head.textContent = tpl.dataset.heading;
    box.hidden = false;
    fetch(cartUrl + '.js').then(function (r) { return r.json(); }).then(function (c) {
      var inCart = {};
      (c.items || []).forEach(function (i) { inCart[i.variant_id] = true; });
      list.querySelectorAll('[data-gl-upsell-item]').forEach(function (row) {
        if (row.hasAttribute('data-gl-rg-card')) return; // rootgrow: gl-rootgrow.js decides by grams, not presence
        if (inCart[parseInt(row.dataset.variant, 10)]) row.remove();
      });
      box.hidden = !list.querySelector('[data-gl-upsell-item]');
      if (window.glRootgrow) window.glRootgrow.refresh();
    }).catch(function () {});
  }

  function patchNotification() {
    var Ctor = window.customElements && customElements.get('cart-notification');
    if (!Ctor || Ctor.prototype.__glUpsell) return;
    var orig = Ctor.prototype.renderContents;
    Ctor.prototype.renderContents = function (state) {
      orig.call(this, state);
      fillUpsell();
    };
    // Subtotal + free-delivery block re-renders with every add (sections/gl-cart-subtotal.liquid).
    var origSections = Ctor.prototype.getSectionsToRender;
    Ctor.prototype.getSectionsToRender = function () {
      var list = origSections.call(this);
      if (document.getElementById('gl-cart-subtotal')) list = list.concat([{ id: 'gl-cart-subtotal' }]);
      return list;
    };
    Ctor.prototype.__glUpsell = true;
  }
  if (window.customElements) {
    customElements.whenDefined('cart-notification').then(patchNotification);
  }

  /* Desktop modal: a click on the dimmed backdrop closes the notification. */
  document.addEventListener('click', function (e) {
    if (!e.target.classList || !e.target.classList.contains('cart-notification-wrapper')) return;
    var cn = e.target.closest('cart-notification');
    if (cn && typeof cn.close === 'function') cn.close();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gl-upsell-add]');
    if (!btn || btn.dataset.loading) return;
    e.preventDefault();
    btn.dataset.loading = '1'; btn.classList.add('is-loading');
    var items = [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }];
    if (btn.dataset.glRgItems) { try { items = JSON.parse(btn.dataset.glRgItems); } catch (err) {} }
    var body = { items: items, sections: ['cart-notification-button', 'cart-icon-bubble', 'gl-cart-subtotal'], sections_url: window.location.pathname };
    fetch(addUrl, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.classList.remove('is-loading'); delete btn.dataset.loading;
      if (res.status) { btn.textContent = 'Sold out'; btn.disabled = true; return; }
      if (res.sections) {
        swapSection('cart-notification-button', res.sections['cart-notification-button']);
        swapSection('cart-icon-bubble', res.sections['cart-icon-bubble']);
        swapSection('gl-cart-subtotal', res.sections['gl-cart-subtotal']);
      }
      btn.classList.add('is-added');
      btn.innerHTML = '<i class="ph ph-check" aria-hidden="true"></i> Added';
      btn.disabled = true;
      if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gl-upsell', cartData: res });
    }).catch(function () { btn.classList.remove('is-loading'); delete btn.dataset.loading; });
  });
})();
